import { isProd, isTest } from './is-env'

const reset = '\u001B[0m'

// oxlint-disable-next-line typescript/ban-ts-comment, typescript/prefer-ts-expect-error -- cross-runtime browser detection
// @ts-ignore
const isBrowser = typeof window !== 'undefined'
const noColor = isBrowser || isProd || isTest

const green = (str: string) => (noColor ? str : `\u001B[32m${str}${reset}`)
const cyan = (str: string) => (noColor ? str : `\u001B[36m${str}${reset}`)
const gray = (str: string) => (noColor ? str : `\u001B[90m${str}${reset}`)

// oxlint-disable-next-line typescript/no-explicit-any -- log formatter accepts any value
function serializeValue(value: any, maxLength = 200): string {
  if (value === null || value === undefined) {
    return value === null ? 'null' : 'undefined'
  }

  if (typeof value === 'string') {
    const toLog = value.replaceAll('"', '\\"')
    if (toLog.length > maxLength) {
      return green(`"${toLog.slice(0, maxLength)}..."`)
    }
    return green(`"${toLog}"`)
  }

  if (typeof value === 'number') {
    return cyan(`${value}`)
  }

  if (typeof value === 'boolean') {
    return `${value}`
  }

  if (typeof value === 'object' && Array.isArray(value)) {
    // oxlint-disable-next-line typescript/no-unsafe-argument -- recursive any serialization
    return `[${value.map((v) => serializeValue(v)).join(',')}]`
  }

  if (typeof value === 'object') {
    // oxlint-disable-next-line typescript/no-unsafe-argument -- recursive any serialization
    return `{${toLogFmt(value)}}`
  }

  return `${value}`
}

// Single function that works in both environments
// oxlint-disable-next-line typescript/no-explicit-any -- log formatter accepts any value
export function toLogFmt(obj: Record<string, any> | any[]): string {
  if (Array.isArray(obj)) {
    return serializeValue(obj)
  }

  return Object.entries(obj)
    .map(([key, value]) => {
      return `${gray(key)}=${serializeValue(value)}`
    })
    .join(' ')
}
